
import React from 'react';
import { Link } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const currentUser = AuthService.getCurrentUser();
  const userRoles = currentUser ? (Array.isArray(currentUser.roles) ? currentUser.roles : [currentUser.roles]) : [];

  return (
    <div className={`left-side-bar ${isOpen ? 'open' : ''}`}>
      <div className="brand-logo">
        <Link to="/">
          <img src="/images/sdilogo.png" alt="" className="dark-logo" />
          <img
            src="/images/sdilogo.png"
            alt=""
            className="light-logo"
          />
        </Link>
        <div className="close-sidebar" onClick={onClose}>
          <i className="ion-close-round"></i>
        </div>
      </div>
      <div className="menu-block customscroll">
        <div className="sidebar-menu">
          <ul id="accordion-menu">
            {(userRoles.includes('Admin') || userRoles.includes('HR-Manager')) && (
              <li>
                <Link to="/manage-employee" className="dropdown-toggle no-arrow">
                  <span className="micon bi bi-people"></span><span className="mtext">Manage Employees</span>
                </Link>
              </li>
            )}
            {userRoles.includes('Employee') && (
              <li>
                <Link to="/employee-checks" className="dropdown-toggle no-arrow">
                  <span className="micon bi bi-receipt"></span><span className="mtext">Employee Checks</span>
                </Link>
              </li>
            )}
            {userRoles.includes('Admin') && (
              <li>
                <Link to="/employee-checks-summary" className="dropdown-toggle no-arrow">
                  <span className="micon bi bi-file-earmark-spreadsheet"></span><span className="mtext">Checks Summary</span>
                </Link>
              </li>
            )}
            {(userRoles.includes('Admin') || userRoles.includes('HR-Manager') || userRoles.includes('CFO')) && (
              <li>
                <Link to="/applications" className="dropdown-toggle no-arrow">
                  <span className="micon bi bi-file-earmark-text"></span><span className="mtext">Job Applications</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
